import { CatButton } from '@blocks-react/components/Button';
import { RequestServiceActionButtonsProps } from '../types';
export const RequestServiceActionButtons = ({
  backLabel,
  continueBtnProps,
  continueLabel,
  isMD,
  backBtnProps
}: RequestServiceActionButtonsProps) => {
  return (
    <div className="w-100">
      {!isMD ? (
        <div className="d-flex">
          <div className="p-0 pe-1">
            <CatButton {...continueBtnProps}>{continueLabel}</CatButton>
          </div>
          <div className="p-0 ps-1">
            <CatButton {...backBtnProps}>{backLabel}</CatButton>
          </div>
        </div>
      ) : (
        <div className="row px-3">
          <div className="col-6 p-0 pe-1 d-flex">
            <CatButton {...backBtnProps}>{backLabel}</CatButton>
          </div>
          <div className="col-6 p-0 ps-1 d-flex">
            <CatButton {...continueBtnProps}>{continueLabel}</CatButton>
          </div>
        </div>
      )}
    </div>
  );
};
